
import { defineComponent, reactive, ref } from 'vue'
import { TResponse } from "@/module/common"
import { TUserInfoType } from '@/module/login';
import { loginApi, getCurrUser } from "@/api/login";
import { useRouter } from 'vue-router';
import { useStore } from "vuex";
import md5 from "js-md5";
import resetPassword from "./components/resetPassword.vue"
import { ElMessage } from 'element-plus'
import { getQueryVariable } from '@/utils/utitls'
import { keys } from 'xe-utils';
export default defineComponent({
    components: { resetPassword },
    setup() {
        let router = useRouter();
        let store = useStore();
        console.log(getQueryVariable("Key"));

        let { userKey, Key, Times } = router.currentRoute.value.query

        let StudentNumber1 = userKey as string
        let key = Key as string
        let times = parseInt(Times as string)
        let loginForm = reactive({
            mobile: '',
            password: '',
            userKey: '',
            key: '',
            times: 0
        })
        if (StudentNumber1 && Key && Times) {
            loginForm = reactive({
                mobile: '',
                password: '',
                userKey: StudentNumber1,
                key: key,
                times: times
            })

            // login()
        }


        let isShowReset = ref(false)
        let login = async () => {
            // location.reload();
            //重新触发路由
            // store.commit("SET_PERMISSION",null);
            // router.replace('/')
            // window.localStorage.setItem("token",'token');
            // return

            let res: TResponse<string> = await loginApi({
                Mobile: loginForm.mobile,
                Password: !loginForm.password || md5(loginForm.password).toUpperCase(),
                Client: 2,// 1：移动端 2：web端
                UserKey: loginForm.userKey,
                Key: loginForm.key,
                Times: loginForm.times
            })
            let { Code, Message, Data } = res
            if (Code === 200) {
                window.localStorage.setItem("token", Data);
                await GetCurrUser()
                router.replace('/')
            } else {
                ElMessage.error(Message)
            }
        };
        console.log(StudentNumber1);

        if (StudentNumber1 && Key && Times) {
            // loginForm=reactive({
            //     mobile: '',
            //     password: '',
            //     StudentNumber: StudentNumber1,
            //     Key: Key,
            //     Times:parseInt(Times)
            // })

            login()
        }
        // 获取当前用户信息
        let GetCurrUser = async () => {
            let res: TResponse<TUserInfoType> = await getCurrUser()
            let { Code, Data } = res
            if (Code === 200) {
                window.localStorage.setItem("userinfo", JSON.stringify(Data));
            }
        }
        //打开忘记密码弹窗
        let openResetDialog = () => {
            isShowReset.value = !isShowReset.value
        }
        let closeResetDialog = () => {
            isShowReset.value = false
        }
        return {
            login,
            loginForm,
            isShowReset,
            openResetDialog,
            closeResetDialog,
            userKey
        }
    },
})
